export const FormerlyKnownAsTwitterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M17.3172 14.922L22.5193 9H21.2867L16.7677 14.1409L13.1609 9H9L14.4553 16.7747L9 22.9842H10.2326L15.0019 17.554L18.8117 22.9842H22.9726L17.3172 14.922ZM15.6284 16.8429L15.0748 16.0682L10.6771 9.91H12.5706L16.1207 14.8818L16.672 15.6564L21.2862 22.1186H19.3927L15.6284 16.8429Z"
      fill="currentColor"
    />
  </svg>
)
